import React from "react";

const NoDataFound = ({ text = `No record Found!`, type }) => {
  return (
    <>
      <div className="no_record_wrap">
        <div className="no_data_found " data-testid="no_data_found">
          {text}
        </div>
      </div>
    </>
  );
};

export default NoDataFound;
